/**
 * TrafficStars Click ID Tracker Component
 * Automatically captures and stores TrafficStars click IDs from URL parameters
 * Include this in your root layout to track across all pages
 */

'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { 
  extractClickIdFromUrl, 
  setClickIdCookie, 
  setClickIdStorage,
  getStoredClickId 
} from '@/lib/trafficstars-utils';

export default function TrafficStarsTracker() {
  const searchParams = useSearchParams();
  
  useEffect(() => {
    // Check for click ID in current URL
    const clickIdFromUrl = searchParams.get('ts_click_id') || searchParams.get('clickid');
    
    if (clickIdFromUrl) {
      console.log('[TrafficStars] Click ID detected:', clickIdFromUrl);
      
      // Store in cookie (primary method)
      setClickIdCookie(clickIdFromUrl);
      
      // Store in localStorage (fallback)
      setClickIdStorage(clickIdFromUrl);
      
      console.log('[TrafficStars] Click ID stored successfully');
    } else {
      // Check if we have a stored click ID (for debugging)
      const storedClickId = getStoredClickId();
      if (storedClickId) {
        console.log('[TrafficStars] Existing click ID found:', storedClickId);
      }
    }
  }, [searchParams]);
  
  // This component renders nothing
  return null;
}

